import { WalletCore } from '@aptos-labs/wallet-adapter-core';
export const walletCore = new WalletCore([], {
  network: 'testnet' as any,
});
